import { render } from "./ActionMenu.vue?vue&type=template&id=b4b68652&scoped=true"
import script from "./ActionMenu.vue?vue&type=script&lang=js"
export * from "./ActionMenu.vue?vue&type=script&lang=js"

import "./ActionMenu.vue?vue&type=style&index=0&id=b4b68652&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b4b68652"

export default script